import { Delete } from "@mui/icons-material";
import { Box, Icon, IconButton, TableCell, TextField, Tooltip } from "@mui/material";
import DescontoInput from "pages/registra-venda/DescontoInput";
import { headerWidths, ITrocaRow } from "pages/registra-venda/registra-venda.model";
import { memo } from "react";
import { useAppSelector } from "redux/hooks";

import { customColors, theme } from "theme";
import useCustomLocation from "utils/useCustomLocation";
import { currencyOf } from "utils/util";
import MiniImagem from "./ProdutoImagem/MiniImagem";
import { FichaImagemAssociacao } from "redux/features/imagemReducer";

type ItemRegistraVendaTrocaProps = {
    row: ITrocaRow;
    imagens: Array<FichaImagemAssociacao>
    onChangeQuantidadeTroca: (uuid: string, value: string) => void;
    changeDescontoTroca: (value: number, uuid: string) => void;
    toggleTipoDescontoTroca: (uuid: string) => void;
    onBlurDescontoItemTroca: (value: number, uuid: string) => void;
    saveTempDescontoTroca: (prevDesconto: number, uuid: string) => void;
    onClickDeleteTroca: (uuid: string, nomeProduto: string) => void;
    onOpenImage: (uuidProduto: string) => void;
};

const ItemRegistraVendaTroca = (props: ItemRegistraVendaTrocaProps) => {
    const {
        isTelaRegistraVenda
    } = useCustomLocation();

    const chavesAcesso = useAppSelector(s => s.notaReferenciada.chavesAcesso);

    const NotasReferenciadasIcon = () => {
        if (!props.row.notaReferenciadaInfo) return <></>;
        const notaInfo = props.row.notaReferenciadaInfo;
        const notas = notaInfo?.notas ?? [];
        const qtdNRef = notaInfo?.quantidadeNaoReferenciada ?? 0;
        const hasQtdNRef = qtdNRef > 0;
        const hasNotas = !!notas.length;

        return <IconButton >
            <Tooltip
                title={
                    <Box sx={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
                        {hasNotas && notaInfo?.notas.map(nfr => (<div>{`${nfr.serie}/${nfr.numeroNota} - ${nfr.chaveAcesso}`}</div>))}
                        {!chavesAcesso.length && hasQtdNRef && hasNotas && <div>{`${qtdNRef} ite${qtdNRef === 1 ? 'm' : 'ns'} não ${qtdNRef === 1 ? 'teve' : 'tiveram'} documento de saída encontrado para esse cliente`}</div>}
                        {!hasNotas && <div>SKU não encontrado em documento de saída para esse cliente</div>}
                    </Box>
                }
                componentsProps={{
                    tooltip: {
                        sx: {
                            maxWidth: '310px !important'
                        }
                    }
                }}
            >
                <Icon className={hasNotas ? 'fa-regular fa-file-lines' : 'fa-solid fa-question'} sx={{ color: hasNotas ? "purple" : theme.palette.warning.main, width: "30px" }} />
            </Tooltip>
        </IconButton >;
    };

    return (
        <>
            <MiniImagem
                onOpenImage={props.onOpenImage}
                imagens={props.imagens.filter(e => e.uuidProduto === props.row.produto.uuidProduto)}
                uuidProduto={props.row.produto.uuidProduto}
                descritivo={props.row.produto.descritivo}
                style={{
                    bgcolor: customColors.bgTroca
                }}
            />
            <TableCell sx={{
                color: theme.palette.common.black,
                padding: 0,
                paddingLeft: '15px',
                bgcolor: customColors.bgTroca
            }}>
                {`${props.row.produto.codigoSku} - ${props.row.produto.nome} / ${props.row.produto.cor} / ${props.row.produto.tamanho}`}
            </TableCell>


            <TableCell align="center" sx={{
                width: headerWidths.quantidade,
                color: theme.palette.common.black,
                minWidth: headerWidths.quantidade,
                maxWidth: headerWidths.quantidade,
                padding: 0,
                textAlign: 'center',
                paddingBottom: '10px',
                bgcolor: customColors.bgTroca
            }}>
                <TextField
                    disabled={!!props.row.cupomTroca}
                    inputProps={{ inputMode: 'numeric', min: 1, style: { textAlign: 'center' } }}
                    value={props.row.quantidade}
                    onKeyDown={e => e.key === '.' && e.preventDefault()}
                    onChange={q => { props.onChangeQuantidadeTroca(props.row.uuid, q.target.value); }}
                    variant="standard"
                    type="number"
                />
            </TableCell>

            <TableCell align="center" sx={{
                width: headerWidths.valorUnitario,
                color: theme.palette.common.black,
                minWidth: headerWidths.valorUnitario,
                maxWidth: headerWidths.valorUnitario,
                padding: 0,
                textAlign: 'center',
                bgcolor: customColors.bgTroca
            }}   >
                {currencyOf(props.row.produto.preco)}
            </TableCell>

            <TableCell align="center" sx={{
                width: headerWidths.desconto,
                color: theme.palette.common.black,
                minWidth: headerWidths.desconto,
                maxWidth: headerWidths.desconto,
                padding: 0,
                textAlign: 'center',
                paddingBottom: '18px',
                bgcolor: customColors.bgTroca
            }}>
                <DescontoInput
                    item={{
                        tipoDesconto: props.row.itemDesconto.tipoDesconto,
                        valorDesconto: props.row.itemDesconto.valorDesconto,
                        percentualDesconto: props.row.itemDesconto.percentualDesconto,
                        valorTotalBruto: props.row.produto.preco * props.row.quantidade,
                        uuid: props.row.uuid,
                        onChangeDesconto: props.changeDescontoTroca,
                    }}
                    inputProps={{ style: { textAlign: 'center', } }}
                    iconButtonProps={{
                        onToggleTipoDesconto: props.toggleTipoDescontoTroca,
                        percentoProps: {
                            color: theme.palette.text.primary,
                        },
                        valorProps: {
                            color: theme.palette.text.primary,
                        }
                    }}
                    onBlur={props.onBlurDescontoItemTroca}
                    onSaveTempDesconto={props.saveTempDescontoTroca}
                    origem="ROW_TROCA"
                />
            </TableCell>

            <TableCell align="center" sx={{
                color: (props.row.brinde) ? theme.palette.text.disabled : theme.palette.common.black,
                width: headerWidths.total,
                minWidth: headerWidths.total,
                maxWidth: headerWidths.total,
                padding: 0,
                textAlign: 'center',
                bgcolor: customColors.bgTroca
            }}>
                {currencyOf(props.row.valorTotal)}
            </TableCell>

            <TableCell align="center" sx={{
                color: (props.row.brinde) ? theme.palette.text.disabled : theme.palette.common.black,
                width: headerWidths.brinde,
                minWidth: headerWidths.brinde,
                maxWidth: headerWidths.brinde,
                textAlign: 'center',
                bgcolor: customColors.bgTroca
            }}>
                {isTelaRegistraVenda() &&
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <IconButton
                            style={{ color: "green" }}
                        >
                            <Tooltip title="Produto da troca">
                                <Icon className="fa-solid fa-retweet" sx={{ color: "green", width: "30px" }} />
                            </Tooltip>
                        </IconButton>

                        <NotasReferenciadasIcon key={props.row.produto.codigoSku + props.row.uuid} />
                    </Box>
                }
            </TableCell>

            <TableCell align="right" sx={{
                width: headerWidths.lixeira,
                minWidth: headerWidths.lixeira,
                maxWidth: headerWidths.lixeira,
                textAlign: 'center',
                bgcolor: customColors.bgTroca
            }}>
                <IconButton
                    onClick={() => props.onClickDeleteTroca(props.row.uuid, props.row.produto.nome)}
                    style={{ color: theme.palette.text.primary, }}
                >
                    <Delete />
                </IconButton>
            </TableCell>
        </>
    );
};

export default memo(ItemRegistraVendaTroca);
